<template>
  <div>
    <v-content>
    <v-layout row class="ml-4 mt-4 mr-2">
      <div :class="ui.textHeadline">
        {{this.companyTitle2}} sign in
      </div>
      <v-spacer/>
      <div :class="ui.responseShowXs">
        <v-btn flat icon small :color="ui.btnColor" :to="'/resetpass'">
          <v-icon dark>vpn_key</v-icon>
        </v-btn>
      </div>
      <div :class="ui.responseHideXs">
        <v-btn outline small :color="ui.btnColor" :to="'/resetpass'">
          <v-icon dark left>vpn_key</v-icon>
          password reset
        </v-btn>
      </div>
      <div :class="ui.responseShowXs">
        <v-btn flat icon small :color="ui.btnColor" :to="'/signup'">
          <v-icon dark>person_add</v-icon>
        </v-btn>
      </div>
      <div :class="ui.responseHideXs">
        <v-btn outline small :color="ui.btnColor" :to="'/signup'">
          <v-icon dark left>person_add</v-icon>
          sign up
        </v-btn>
      </div>
      <div :class="ui.responseShowXs">
        <v-btn flat icon small :color="ui.btnColor" :to="'/'">
          <v-icon dark>home</v-icon>
        </v-btn>
      </div>
      <div :class="ui.responseHideXs">
        <v-btn outline small :color="ui.btnColor" :to="'/'">
          <v-icon dark left>home</v-icon>
          home
        </v-btn>
      </div>
    </v-layout>
    <v-container>
    <v-layout>
      <v-flex xs12 sm6 lg4 offset-sm3 offset-lg4>
        <v-card :class="ui.cardColorPure">
          <v-img class="white--text" :height="ui.sizeHeightDialogSmall"
          :src="require('@/app/assets/images/plant01.jpg')">
           <v-container fill-height fluid>
             <v-layout fill-height>
               <v-flex xs12 align-end flexbox>
                 <span :class="ui.textHeadlineLight"> {{this.message}} </span>
               </v-flex>
             </v-layout>
           </v-container>
         </v-img>
          <v-layout row>
            <v-spacer/>
            <div :class="ui.textImage"> Queensland Alumina Limited, Copyright © 2018 Rio Tinto. </div>
          </v-layout>

          <v-card-text>
            <v-form
              ref="form"
              v-model="valid"
              lazy-validation
            >
              <v-text-field
                v-model="email"
                label="user email"
                :rules="emailRules"
                prepend-icon="mail"
                required
                autocomplete="username"
                @keyup.enter="validate"
              ></v-text-field>
              <v-text-field
                v-model="password"
                label="user password"
                :rules="passwordRules"
                prepend-icon="vpn_key"
                required
                type="password"
                autocomplete="current-password"
                @keyup.enter="validate"
              ></v-text-field>
              <v-text-field
                v-model="systemPassword"
                label="system password"
                prepend-icon="pin"
                readonly
              ></v-text-field>
              <v-layout row class="mt-1 ml-4"
              v-if="this.message !== 'sign in'">
                <div :class="ui.textSubheadingWarning">
                  {{this.message}}
                </div>
              </v-layout>
              <v-layout row class="mt-1">
                  <v-btn
                  v-if="true"
                  :color="ui.btnColor" flat :to="'/resetpass'">
                    <v-icon left> vpn_key </v-icon>
                    reset
                  </v-btn>
                <v-spacer/>
                <div v-if="enableBtnSpinSignin === false">
                  <v-btn
                    v-if="this.message === 'sign in'"
                    :disabled="!valid"
                    :color="ui.btnColor"
                    @click="validate"
                    flat
                  >
                    <v-icon left> person </v-icon>
                    sign in
                  </v-btn>
                  <v-btn
                    v-else
                    :disabled="!valid"
                    :color="ui.btnColorWarning"
                    @click="validate"
                    flat
                  >
                    <v-icon left> redo </v-icon>
                    retry
                  </v-btn>
                </div>
                <div v-else>
                  <BtnSpin :btnSpec="btnInfo1"/>
                </div>
              </v-layout>
              <v-layout row class="mt-4">
                <PublicFooterCard :data="{bkgd: 'white'}"/>
              </v-layout>
            </v-form>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    </v-container>
  </v-content>

  </div>
</template>

<script>
import BtnSpin from "@/frame/animation/components/BtnSpin";
import signinUser from "../mixins/signinUser.js";
import formSignup from "@/data/rules/mixins/formSignup.js";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import publicGlobals from "@/data/globals/mixins/publicGlobals.js";
import PublicFooterCard from "@/public/components/PublicFooterCard";
export default {
  components: {
    BtnSpin,
    PublicFooterCard
  },
  mixins: [signinUser, formSignup, apptheme, publicGlobals],
  data: () => ({
    valid: true,
    enableBtnSpinSignin: false,
    systemPassword: "System Access Confirmed",
    btnInfo1: {
      color: "red",
      icon: "person",
      name: "add user",
      btnType: "flat"
    }
  })
};
</script>
